<template>
  <div class="wrap">
    <el-input
      class="area"
      v-model="inputValue" 
      :autofocus="autofocus"
      :class="errorSignal ? 'error-border' : ''"
      :minlength="min"
      :maxlength="max"
      :placeholder="placeholder"
      v-bind="$attrs"
      v-on="$listeners"
      @focus="inputFocus"
      @blur="inputBlur">
    </el-input>
    <p v-if="errorSignal" class="error-text">{{errMessage}}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      change: '',
      errorSignal: false
    }
  },

  props: {
    value: {},

    placeholder: {
      type: String,
      default: '请输入'
    },

    autofocus: {
      type: Boolean,
      default: false
    },

    min: {
      type: String,
      default: '0'
    },

    max: {
      type: String,
      default: '1000'
    },

    errMessage: {
      type: String,
      default: ''
    }
  },

  computed: {
    inputValue: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  },

  watch: {
    errMessage(val) {
      if (val) {
        this.errorSignal = true
      } else {
        this.errorSignal = false
      }
    },

    inputValue(val) {
      // 这种情况说明是外部赋值致使input的值发生改变 (表单回填)
      if (val && !this.change) {
        this.change = 'blur'
      }
    }
  },

  methods: {
    inputFocus() {
      this.change = 'focus'
      this.errorSignal = false
    },

    inputBlur() {
      if (this.inputValue !== '') {
        this.change = 'blur'
      } else {
        this.change = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  position: relative;

  .area {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #333333;
  }

  .focus {
    font-size: 12px;
    color: #08A681;
    padding: 2px 3px;
    font-weight: bolder;
    letter-spacing: 0;
    line-height: 16px;
    transform: translate(-2px, -22px);
  }

  .blur {
    font-size: 12px;
    color: #666666;
    padding: 2px 3px;
    letter-spacing: 0;
    line-height: 16px;
    transform: translate(-2px, -22px);
  }

  .error-border {
    /deep/ input {
      border: 1px solid #E51C23;
    }
  }

  .error-text {
    padding: 10px 0 0 4px;
    font-size: 12px;
    color: #E51C23;
  }
}
</style>
